import { ROUTES } from '@/lib/constants/routes';
import { withPurchaseIntent } from '@/lib/utils/purchase-intent.utils';
import { peekPurchaseIntent } from './intent-storage';
import { hasStartupInviteLanding } from './startup-invite-landing';

/**
 * Where a user lands once they are signed in, after login, email verification
 * or authenticator setup: the Issue Report journey while a valid purchase
 * intent is stored (FR-206); Create Startup after accepting a startup admin
 * invite (MYN-311); otherwise the dashboard exactly as before. The journey
 * route then decides the next step from the session (FR-204).
 */
export function postAuthLanding(): string {
  if (peekPurchaseIntent()) return ROUTES.ISSUE_REPORT_START;
  return hasStartupInviteLanding() ? ROUTES.CREATE_STARTUP : ROUTES.DASHBOARD;
}

/**
 * The sign-in page for a step inside the login or signup funnel ("Back to sign
 * in", a lost pending login). It carries the stored intent in the URL, because
 * the login page forgets any intent its URL does not name (FR-219).
 */
export function journeySignInPath(): string {
  return withPurchaseIntent(ROUTES.AUTH.LOGIN, peekPurchaseIntent());
}

/** The register page for a step inside the signup funnel, keeping the stored intent the same way. */
export function journeyRegisterPath(): string {
  return withPurchaseIntent(ROUTES.AUTH.REGISTER, peekPurchaseIntent());
}

